import _ from 'lodash'

import getters from '../rev/getters'
import mutations from './mutations'
import actions from './actions'
import state from './state'

export default {
  namespaced: true,
  state: _.cloneDeep(state),
  getters,
  actions,
  mutations,
}
